var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.28571C4 9.53571 4.17857 9.71429 4.42857 9.71429H5.85714C6.07143 9.71429 6.28571 9.53571 6.28571 9.28571V6.28571H9.28571C9.5 6.28571 9.71429 6.10714 9.71429 5.85714V4.42857C9.71429 4.21429 9.5 4 9.28571 4H4.85714C4.35714 4 4 4.39286 4 4.85714V9.28571ZM14.2857 4.42857V5.85714C14.2857 6.10714 14.4643 6.28571 14.7143 6.28571H17.7143V9.28571C17.7143 9.53571 17.8929 9.71429 18.1429 9.71429H19.5714C19.7857 9.71429 20 9.53571 20 9.28571V4.85714C20 4.39286 19.6071 4 19.1429 4H14.7143C14.4643 4 14.2857 4.21429 14.2857 4.42857ZM19.5714 14.2857H18.1429C17.8929 14.2857 17.7143 14.5 17.7143 14.7143V17.7143H14.7143C14.4643 17.7143 14.2857 17.9286 14.2857 18.1429V19.5714C14.2857 19.8214 14.4643 20 14.7143 20H19.1429C19.6071 20 20 19.6429 20 19.1429V14.7143C20 14.5 19.7857 14.2857 19.5714 14.2857ZM9.71429 19.5714V18.1429C9.71429 17.9286 9.5 17.7143 9.28571 17.7143H6.28571V14.7143C6.28571 14.5 6.07143 14.2857 5.85714 14.2857H4.42857C4.17857 14.2857 4 14.5 4 14.7143V19.1429C4 19.6429 4.35714 20 4.85714 20H9.28571C9.5 20 9.71429 19.8214 9.71429 19.5714Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.ee8ea3b0fd7dcb10ec07ac53629c0368.svg";
export { ForwardRef as ReactComponent };